import React from 'react';

export default function Question6(){
    return(
        <div className="question mt-40">
            <h4 id='q6' className="h-4 h-bold">
                <span style={{opacity:"0.4", marginRight:"10px"}}>
                    07.
                </span>
                Personnel
            </h4>
            <p className="paragraph p-adjustment text-left">
            If you are an Invoice Point worker or applicant, we collect the information you voluntarily provide to us. We use the information collected for human resources purposes in order to administer benefits to workers and screen applicants. You may contact us in order to (1) update or correct your information, (2) change your preferences with respect to communications and other information you receive from us, or (3) receive a record of the information we have relating to you. Such updates, corrections, changes and deletions will have no effect on other information that we maintain, or information that we have provided to third parties in accordance with this Privacy Policy prior to such update, correction, change, or deletion.
            </p>
        </div>
    )
}